import { Injectable } from '@angular/core';
import { IOperator } from 'src/app/models';
import { CommunicationUserType } from 'src/app/models/enums';
import { AuthService } from '../auth/auth.service';
import { MessageService } from '../message/message.service';
import { UsersService } from '../users/users.service';

@Injectable({
  providedIn: 'root',
})
export class FilterOptionsService {
  private readonly requests = new Map<string, Promise<unknown>>();
  private requestsUserId?: string;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private messageService: MessageService,
  ) {}

  getPossibleClientTowns(): Promise<{ clients: any[]; towns: any[] }> {
    return this.cached('clientTowns', () => this.usersService.getPossibleClientTowns());
  }

  getOperators(): Promise<IOperator[]> {
    return this.cached('operators', () => this.usersService.getOperators());
  }

  getOperatorsByClient(clientIds: number[]): Promise<any> {
    return this.cached(`operatorsByClient:${this.clientsKey(clientIds)}`, () =>
      this.usersService.getOperatorsByClient(clientIds),
    );
  }

  getTownsByClient(clientIds: number[]): Promise<any> {
    return this.cached(`townsByClient:${this.clientsKey(clientIds)}`, () =>
      this.usersService.getTownsByClient(clientIds),
    );
  }

  getSenders(userType: CommunicationUserType): Promise<any> {
    return this.cached(`senders:${userType}`, () => this.messageService.getSenders(userType));
  }

  private clientsKey(clientIds: number[]): string {
    return [...clientIds].sort((first, second) => first - second).join(',');
  }

  private cached<T>(key: string, load: () => Promise<T>): Promise<T> {
    const userId = this.authService.getUserId();
    if (userId !== this.requestsUserId) {
      this.requests.clear();
      this.requestsUserId = userId;
    }
    const cachedRequest = this.requests.get(key) as Promise<T> | undefined;
    if (cachedRequest) return cachedRequest;
    const request = load().catch((error) => {
      this.requests.delete(key);
      throw error;
    });
    this.requests.set(key, request);
    return request;
  }
}
